import styles from './JumpLinkGroup.module.scss'
import ArrowRight from '../../../public/assets/svg/arrow-right.svg'
import { Container } from 'react-grid-system'
import { Fragment, useEffect } from 'react'

interface JumpLinkProps {
  jumpLinkHref: string
  jumpLinkTitle: string
  id?: string
}

const scrollToSection = (id: string) => {
  const headerHeight = document.getElementsByTagName('header')[0]?.offsetHeight || 0
  const target = document.getElementById(id.replace('#', ''))
  if (target) {
    const targetPos = target.getBoundingClientRect().top + window.scrollY - headerHeight
    window.scrollTo({ top: targetPos, behavior: 'smooth' })
  }
}

const JumpLink = ({ jumpLinkHref, jumpLinkTitle }: JumpLinkProps) => {
  const handleClick = () => {
    window.history.replaceState(null, '', jumpLinkHref)
    scrollToSection(jumpLinkHref)
  }

  return (
    <div className={styles.jumpLinkContainer} onClick={handleClick}>
      <span>{jumpLinkTitle}</span>
      <ArrowRight />
    </div>
  )
}

const JumpLinkGroup = ({ jumpLinks }: { jumpLinks: JumpLinkProps[] }) => {
  useEffect(() => {
    if (window.location.hash) {
      const tryScroll = () => {
        const target = document.getElementById(window.location.hash.replace('#', ''))
        if (target) {
          scrollToSection(window.location.hash)
        } else {
          requestAnimationFrame(tryScroll)
        }
      }
      tryScroll()
    }
  }, [])

  return (
    <Container>
      <div className={styles.jumpLinkGroupContainer}>
        {jumpLinks.map(({ id, jumpLinkHref, jumpLinkTitle }: JumpLinkProps) => (
          <Fragment key={id}>
            <JumpLink jumpLinkHref={jumpLinkHref} jumpLinkTitle={jumpLinkTitle} />
          </Fragment>
        ))}
      </div>
    </Container>
  )
}

export default JumpLinkGroup
